// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/packages/v1/packages.proto" (package "viam.app.packages.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { Struct } from "../../../google/protobuf/struct";
/**
 * @generated from protobuf message viam.app.packages.v1.FileInfo
 */
export interface FileInfo {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: uint64 size = 2;
     */
    size: string;
    /**
     * @generated from protobuf field: optional bool is_directory = 3;
     */
    isDirectory?: boolean;
}
/**
 * @generated from protobuf message viam.app.packages.v1.PackageInfo
 */
export interface PackageInfo {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string version = 3;
     */
    version: string;
    /**
     * @generated from protobuf field: viam.app.packages.v1.PackageType type = 4;
     */
    type: PackageType;
    /**
     * @generated from protobuf field: optional string platform = 7;
     */
    platform?: string;
    /**
     * @generated from protobuf field: repeated viam.app.packages.v1.FileInfo files = 5;
     */
    files: FileInfo[];
    /**
     * @generated from protobuf field: google.protobuf.Struct metadata = 6;
     */
    metadata?: Struct;
}
/**
 * @generated from protobuf message viam.app.packages.v1.CreatePackageRequest
 */
export interface CreatePackageRequest {
    /**
     * @generated from protobuf oneof: package
     */
    package: {
        oneofKind: "info";
        /**
         * @generated from protobuf field: viam.app.packages.v1.PackageInfo info = 1;
         */
        info: PackageInfo;
    } | {
        oneofKind: "contents";
        /**
         * .tar.gz file
         *
         * @generated from protobuf field: bytes contents = 2;
         */
        contents: Uint8Array;
    } | {
        oneofKind: undefined;
    };
}
/**
 * Returns the package ID and version which are populated in GetPackageRequest and DeletePackageRequest to
 * retrieve or delete this package.
 *
 * @generated from protobuf message viam.app.packages.v1.CreatePackageResponse
 */
export interface CreatePackageResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string version = 2;
     */
    version: string;
}
/**
 * @generated from protobuf message viam.app.packages.v1.DeletePackageRequest
 */
export interface DeletePackageRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string version = 2;
     */
    version: string;
    /**
     * @generated from protobuf field: viam.app.packages.v1.PackageType type = 3;
     */
    type: PackageType;
}
/**
 * @generated from protobuf message viam.app.packages.v1.DeletePackageResponse
 */
export interface DeletePackageResponse {
}
/**
 * @generated from protobuf message viam.app.packages.v1.Package
 */
export interface Package {
    /**
     * @generated from protobuf field: viam.app.packages.v1.PackageInfo info = 1;
     */
    info?: PackageInfo;
    /**
     * @generated from protobuf field: string url = 2;
     */
    url: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 3;
     */
    createdOn?: Timestamp;
    /**
     * @generated from protobuf field: string checksum = 4;
     */
    checksum: string;
    /**
     * @generated from protobuf field: string id = 5;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.packages.v1.GetPackageRequest
 */
export interface GetPackageRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string version = 2;
     */
    version: string;
    /**
     * @generated from protobuf field: optional bool include_url = 3;
     */
    includeUrl?: boolean;
    /**
     * @generated from protobuf field: optional viam.app.packages.v1.PackageType type = 4;
     */
    type?: PackageType;
    /**
     * @generated from protobuf field: optional string platform = 5;
     */
    platform?: string;
}
/**
 * @generated from protobuf message viam.app.packages.v1.GetPackageResponse
 */
export interface GetPackageResponse {
    /**
     * @generated from protobuf field: viam.app.packages.v1.Package package = 1;
     */
    package?: Package;
}
/**
 * @generated from protobuf message viam.app.packages.v1.ListPackagesRequest
 */
export interface ListPackagesRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: optional string name = 2;
     */
    name?: string;
    /**
     * @generated from protobuf field: optional string version = 3;
     */
    version?: string;
    /**
     * @generated from protobuf field: optional viam.app.packages.v1.PackageType type = 4;
     */
    type?: PackageType;
    /**
     * @generated from protobuf field: optional bool include_url = 5;
     */
    includeUrl?: boolean;
}
/**
 * @generated from protobuf message viam.app.packages.v1.ListPackagesResponse
 */
export interface ListPackagesResponse {
    /**
     * @generated from protobuf field: repeated viam.app.packages.v1.Package packages = 1;
     */
    packages: Package[];
}
/**
 * @generated from protobuf enum viam.app.packages.v1.PackageType
 */
export enum PackageType {
    /**
     * @generated from protobuf enum value: PACKAGE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PACKAGE_TYPE_ARCHIVE = 1;
     */
    ARCHIVE = 1,
    /**
     * @generated from protobuf enum value: PACKAGE_TYPE_ML_MODEL = 2;
     */
    ML_MODEL = 2,
    /**
     * @generated from protobuf enum value: PACKAGE_TYPE_MODULE = 3;
     */
    MODULE = 3,
    /**
     * @generated from protobuf enum value: PACKAGE_TYPE_SLAM_MAP = 4;
     */
    SLAM_MAP = 4,
    /**
     * @generated from protobuf enum value: PACKAGE_TYPE_ML_TRAINING = 5;
     */
    ML_TRAINING = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class FileInfo$Type extends MessageType<FileInfo> {
    constructor() {
        super("viam.app.packages.v1.FileInfo", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "size", kind: "scalar", T: 4 /*ScalarType.UINT64*/ },
            { no: 3, name: "is_directory", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.packages.v1.FileInfo
 */
export const FileInfo = new FileInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PackageInfo$Type extends MessageType<PackageInfo> {
    constructor() {
        super("viam.app.packages.v1.PackageInfo", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "type", kind: "enum", T: () => ["viam.app.packages.v1.PackageType", PackageType, "PACKAGE_TYPE_"] },
            { no: 7, name: "platform", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "files", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FileInfo },
            { no: 6, name: "metadata", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.packages.v1.PackageInfo
 */
export const PackageInfo = new PackageInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreatePackageRequest$Type extends MessageType<CreatePackageRequest> {
    constructor() {
        super("viam.app.packages.v1.CreatePackageRequest", [
            { no: 1, name: "info", kind: "message", oneof: "package", T: () => PackageInfo },
            { no: 2, name: "contents", kind: "scalar", oneof: "package", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.packages.v1.CreatePackageRequest
 */
export const CreatePackageRequest = new CreatePackageRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreatePackageResponse$Type extends MessageType<CreatePackageResponse> {
    constructor() {
        super("viam.app.packages.v1.CreatePackageResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.packages.v1.CreatePackageResponse
 */
export const CreatePackageResponse = new CreatePackageResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeletePackageRequest$Type extends MessageType<DeletePackageRequest> {
    constructor() {
        super("viam.app.packages.v1.DeletePackageRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "enum", T: () => ["viam.app.packages.v1.PackageType", PackageType, "PACKAGE_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.packages.v1.DeletePackageRequest
 */
export const DeletePackageRequest = new DeletePackageRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeletePackageResponse$Type extends MessageType<DeletePackageResponse> {
    constructor() {
        super("viam.app.packages.v1.DeletePackageResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.packages.v1.DeletePackageResponse
 */
export const DeletePackageResponse = new DeletePackageResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Package$Type extends MessageType<Package> {
    constructor() {
        super("viam.app.packages.v1.Package", [
            { no: 1, name: "info", kind: "message", T: () => PackageInfo },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "created_on", kind: "message", T: () => Timestamp },
            { no: 4, name: "checksum", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.packages.v1.Package
 */
export const Package = new Package$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPackageRequest$Type extends MessageType<GetPackageRequest> {
    constructor() {
        super("viam.app.packages.v1.GetPackageRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "include_url", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "type", kind: "enum", opt: true, T: () => ["viam.app.packages.v1.PackageType", PackageType, "PACKAGE_TYPE_"] },
            { no: 5, name: "platform", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.packages.v1.GetPackageRequest
 */
export const GetPackageRequest = new GetPackageRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPackageResponse$Type extends MessageType<GetPackageResponse> {
    constructor() {
        super("viam.app.packages.v1.GetPackageResponse", [
            { no: 1, name: "package", kind: "message", T: () => Package }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.packages.v1.GetPackageResponse
 */
export const GetPackageResponse = new GetPackageResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPackagesRequest$Type extends MessageType<ListPackagesRequest> {
    constructor() {
        super("viam.app.packages.v1.ListPackagesRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "type", kind: "enum", opt: true, T: () => ["viam.app.packages.v1.PackageType", PackageType, "PACKAGE_TYPE_"] },
            { no: 5, name: "include_url", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.packages.v1.ListPackagesRequest
 */
export const ListPackagesRequest = new ListPackagesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPackagesResponse$Type extends MessageType<ListPackagesResponse> {
    constructor() {
        super("viam.app.packages.v1.ListPackagesResponse", [
            { no: 1, name: "packages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Package }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.packages.v1.ListPackagesResponse
 */
export const ListPackagesResponse = new ListPackagesResponse$Type();
/**
 * @generated ServiceType for protobuf service viam.app.packages.v1.PackageService
 */
export const PackageService = new ServiceType("viam.app.packages.v1.PackageService", [
    { name: "CreatePackage", clientStreaming: true, options: { "google.api.http": { post: "/packages/v1/create" } }, I: CreatePackageRequest, O: CreatePackageResponse },
    { name: "DeletePackage", options: { "google.api.http": { delete: "/packages/v1/delete" } }, I: DeletePackageRequest, O: DeletePackageResponse },
    { name: "GetPackage", options: { "google.api.http": { get: "/packages/v1/get" } }, I: GetPackageRequest, O: GetPackageResponse },
    { name: "ListPackages", options: { "google.api.http": { get: "/packages/v1/list" } }, I: ListPackagesRequest, O: ListPackagesResponse }
]);
